import { createToolTip } from './utils';
import { DatePipe } from '@angular/common';
import { GlobalVariables } from '../../../../common/global-variables';

var timezones = require('./timezone-picker/timezones.json');
var $ = require('jquery');
const _ = require('lodash');

/* If empty, returns a place holder (by default '-') */
function handleEmptyValues (value, emptyCharacter = '-') {
  return value ? value : emptyCharacter;
}

/* Truncate longer strings, to show '...' and then on mouse over show the complete text as a tooltip */
function truncateString(str, truncateLength = 30, tooltipClasses='"tooltip tooltip-sm tooltip-right"'){
  var returnString = "", tooltipString = str;
  if(str && truncateLength && str.length > truncateLength){
    str = str.substring(0,truncateLength) + '...';
    returnString = createToolTip('<span>'+str+'</span>', tooltipString, tooltipClasses);
  }
  else
    returnString = tooltipString;
  return returnString;
}

function genericStringFormatter(str,customWidth="95"){ // customWidth = 95% default in css
  if (str && $.trim(str) != "-") {
    var customStyle = "";
    if (customWidth && parseInt(customWidth) > 0) {
      customStyle = "style=max-width:"+customWidth;
    }
    var returnString = createToolTip('<span '+customStyle+' class="air-table-cell">'+str+'</span>', str);
    return returnString;
  }else{
    return str;
  }
}

function genericDateFormatter(dateString: string, dateFormat: string = 'EEE MMM dd y HH:mm:ss Z') {
  let datePipe: DatePipe = new DatePipe(GlobalVariables.LOCALE);
  return datePipe.transform(new Date(dateString), dateFormat);
}

function genericDateFormatterWithToolTip(dateString: string, tooltipFormat: string = 'EEE MMM dd y HH:mm:ss Z', dateFormat: string = 'MMM dd y HH:mm:ss') {
  let tooltipText = genericDateFormatter(dateString, tooltipFormat);
  let shortDateText = genericDateFormatter(dateString, dateFormat);
  return createToolTip('<span>' + shortDateText + '</span>', tooltipText);
}

function restorePointRender(data, type, row){
  var subrowStyle = ' - ';
  var restorePointCount =  (row && row.statistics && row.statistics.restorePointCount) ? row.statistics.restorePointCount : 0;
  subrowStyle     = '<span><a class="restore-points">' + restorePointCount + '</a></span>';
  return subrowStyle;
}

function statusRender(data, type, row, translate){
  let statusText;
  if(row && row.status) {
    statusText = statusFormatter(data, translate);
  }
  return statusText;
}

function statusFormatter(data, translate) {
  let statusText = ' - ';
  if(data && data !== "") {
    if ( data == "success" ) {
      statusText = '<span class="label label-success">' + translate.instant('common.statuses.success') + '</span>';
    }
    else if ( data == "failed" ) {
      statusText = '<span class="label label-danger">' + translate.instant('common.statuses.failed') + '</span>';
    }
    else if ( data == "partialSuccess" || data == "partial" ) {
      statusText = '<span class="label label-info">' + translate.instant('common.statuses.partial') + '</span>';
    }
    else {
      statusText = '<span class="label label-info">' + translate.instant('common.statuses.running') + '</span>';
    }
  }
  return statusText;
}

 /* Takes storage in MB and converts to higher */
function storageRender(data, type, row) {
  var returnString = "0 MB";
  if(row && row.statistics && row.statistics.storageConsumed){
    returnString = storageConverterRender(row.statistics.storageConsumed, 'MB');
  } else if(row && row.storageConsumed) {
    returnString = storageConverterRender(row.storageConsumed, 'MB');
  }
  return returnString;
}
function storageConverterRender(storage, unit) {
  var returnString = "0 MB";
  if(storage && unit){
    var resultObj = unitConverter(Number(storage), unit);
    returnString = resultObj.number + ' ' + resultObj.unit;
  }
  return returnString;
}
function unitConverter(number, unit, significantDigitCount = 3) {
  var unitPrefixes = [' ', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];

  if (number == 0) {
      return {
          number: number,
          unit: unit
      };
  }

  var power = Math.log(number > 0 ? number: -number) / Math.LN10;
  var roundedPower = Math.floor(power);
  if (roundedPower + 1 - power < 0.000001) { // To handle round-off errors in cases like 1000 MHz
      roundedPower += 1;
  }

  var unitShift = Math.floor(roundedPower/3);

  var newNumber = 0;
  if (unit.charAt(0) == 'B' || unit.charAt(1) == 'B') {  // bytes case
      newNumber = number / Math.pow(1024, unitShift);
  } else {
      newNumber = number / Math.pow(10, 3*unitShift);
  }

  var trimmedNumber:any = (Math.round(newNumber * Math.pow(10, significantDigitCount - 1)))/Math.pow(10, significantDigitCount - 1);

  var newUnit = '';
  var newUnitPrefix = '';
  var newUnitPrefixPosition = $.inArray(unit.charAt(0), unitPrefixes) + unitShift;
  if (newUnitPrefixPosition >=0 && newUnitPrefixPosition <= 8) {
      newUnitPrefix = unitPrefixes[newUnitPrefixPosition];
      newUnit = newUnitPrefix.concat(unit.substr(1));
  } else {  // doesn't handle extreme cases
      return {
          number: number,
          unit: unit
      };
  }

  var toBeFixed = significantDigitCount - (roundedPower - 3*unitShift) -1;
  if (toBeFixed >= 0) {
      trimmedNumber = trimmedNumber.toFixed(toBeFixed);
  }

  return {
      number: trimmedNumber,
      unit: newUnit
  };
}

/* Generic Policy Column render for Tables.
* Handles the daily, weekly and yearly shedules
*/
function policyRender(data, type, row){
  var policytext = policyFormatter(row);
  var tooltiptext = tooltipFormatter(row);

  policytext += retentionFormatter(row);
  var wrapperElement = createToolTip('<span>'+policytext+'</span>', tooltiptext);
  return wrapperElement;
}

/* Formats Policy based on the scheduleType */
function policyFormatter(row) {
  var policytext = " - ";
  if(row.schedule && row.schedule.scheduleType) {
    switch(row.schedule.scheduleType) {
      case 'Daily':
          policytext = 'Daily at ' + timeFormatter(row);
        break;
      case 'Weekly':
          policytext = 'Weekly, Every ' + daysFormatter(row) + ' at ' + timeFormatter(row);
        break;
      case 'Monthly':
          policytext = 'Monthly, On ' + dateFormatter(row) + ' at ' + timeFormatter(row);
        break;
      case 'Yearly':
          policytext = 'Yearly, ' + dateFormatter(row) + ' of ' + monthFormatter(row) + ' at ' + timeFormatter(row);
        break;
    }
  }
  return policytext;
}


function tooltipFormatter(row) {
  return policyFormatter(row) + timezoneFormatter(row) + retentionFormatter(row)
}

function replicationTooltipFormatter(row) {
  return policyFormatter(row) + timezoneFormatter(row);
}

/* extracts the time from row and converts "13:30:00" format to "0130PM"  */
function timeFormatter(row){
  var formattedTime = ' - ';
  if (row && row.schedule && row.schedule.startTime && row.schedule.startTime != "") {
    var tArray = row.schedule.startTime.split(":");
    if(tArray && tArray instanceof Array && tArray.length > 0) {
      var hours = Number(tArray[0]);
      var mins = (tArray[1])? tArray[1] : "00";
      var suffix = (hours >= 12) ? "PM":"AM";
      hours = ((hours + 11) % 12 + 1);
      formattedTime = ((hours < 10)? '0'+hours : hours) + ":" + mins + "" + suffix;
    }
  }
  return formattedTime;
}

function timezoneFormatter(row){
  var returnString = '';
  if(row && row.schedule && row.schedule.timeZone ){
    returnString = ' [' + findTZLabel(row.schedule.timeZone) + ']';
  }
  return returnString;
}
function daysFormatter(row){
  var returnString = '';
  if(row && row.schedule && row.schedule.days && row.schedule.days instanceof Array ){
    returnString = arrayToString(row.schedule.days);
  }
  return returnString;
}
function dateFormatter(row){
  var returnString = '';
  if(row && row.schedule && row.schedule.dates && row.schedule.dates instanceof Array ){
    returnString = arrayToString(row.schedule.dates);
    if(returnString == '1')
      returnString += 'st';
    else if(returnString == '2')
      returnString += 'nd';
    else if(returnString == '3')
      returnString += 'rd';
    else
      returnString += 'th';
  }
  return returnString;
}
function monthFormatter(row){
  var returnString = '';
  if(row && row.schedule && row.schedule.months && row.schedule.months instanceof Array ){
    returnString = arrayToString(row.schedule.months);
  }
  return returnString;
}

function retentionFormatter(row){
  var returnString = '';
  if(row && row.retention && row.retention.days){
    returnString = ' | Retention: ' + row.retention.days + ' days';
  }
  return returnString;
}
function arrayToString(arr){
  var returnString = '';
  if(arr && arr instanceof Array ){
    returnString = arr.join(", ");
  }
  return returnString;
}
function findTZLabel(tzValue){
  var returnString = '';
  var tzKeyArray;
  if(timezones && typeof timezones === 'object' && tzValue){
    tzKeyArray = getKeys(timezones, tzValue);
    if(tzKeyArray && tzKeyArray[0])
      returnString = tzKeyArray[0];
  }
  return returnString;
}
/* return an array of keys from an object that match on a certain value */
function getKeys(obj, val){
    var objects = [];
    for (var i in obj) {
        if (!obj.hasOwnProperty(i)) continue;
        if (typeof obj[i] == 'object') {
            objects = objects.concat(getKeys(obj[i], val));
        } else if (obj[i] == val) {
            objects.push(i);
        }
    }
    return objects;
}


//Activity Log Modal specific
function statusRenderActivityLog(data, type, row){
  var returnString = "-";
  if(row && row.status){
    returnString = data;
    if(row.result && (row.status.toLowerCase() !== 'success') && row.result.replace(/^\s+|\s+$/gm,'') != '') {
      returnString = createToolTip('<span><span>'+row.status+'</span>&nbsp;&nbsp;<span class="fa fa-info-circle orange"></span></span>', row.result);
    }
  }
  return returnString;
}


//Deleted vApps Modal specific
const DEL_VAPP_BUSY_STATES = ['INITIATED', 'VALIDATED', 'STARTED', 'TASK_IN_PROGRESS', 'VAPP_RESTORE','VAPP_POST_RESTORE','SCHEDULE_DELETE','SCHEDULE_UPDATE'];
const DEL_VAPP_WARNING_STATES = ['VAPP_RESTORE_PARTIAL_SUCCESS', 'VAPP_BACKUP_PARTIAL_SUCCESS'];
const DEL_VAPP_ERROR_STATES = ['VAPP_RESTORE_FAIL', 'VAPP_BACKUP_FAIL', 'JOB_FAILED'];
const DEL_VAPP_OK_STATES = ['TASK_COMPLETED','JOB_COMPLETED' ,'VAPP_BACKUP_SUCCESS' , 'VAPP_RESTORE_SUCCESS'];

function ongoingRenderDeletedVapps(data, type, row){
  var iconStyle = "";
  if(!row || !row.properties || !row.properties.state || !row.properties.operation){
    return '';
  }

  if(_.indexOf(DEL_VAPP_BUSY_STATES, row.properties.state) != -1){
    switch (row.properties.operation) {
      case 'VAPP_RESTORE_POINT_DELETION_WORKFLOW':
        iconStyle = createToolTip('<span class="spinner spinner-inline"></span>', 'Ongoing Delete All Restore Points Operation');
        break;
      case 'REFRESH_VAPP_RESTORE_POINTS':
        iconStyle = createToolTip('<span class="spinner spinner-inline"></span>', 'Ongoing Refresh Restore Points Operation');
        break;
      default:
        iconStyle = '<span/>';
    }
  }else if(_.indexOf(DEL_VAPP_WARNING_STATES, row.properties.state) != -1){
    switch (row.properties.operation) {
      case 'VAPP_RESTORE_POINT_DELETION_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Delete All Restore Points is Partially Successful');
        break;
      case 'REFRESH_VAPP_RESTORE_POINTS':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Refresh Restore Points is Partially Successful');
        break;
      default:
        iconStyle = '<span/>';
    }
  } else if(_.indexOf(DEL_VAPP_ERROR_STATES, row.properties.state) != -1){
    switch (row.properties.operation) {
      case 'VAPP_RESTORE_POINT_DELETION_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-times-circle-o red"></span>', 'Delete All Restore Points Operation Failed');
        break;
      case 'REFRESH_VAPP_RESTORE_POINTS':
        iconStyle = createToolTip('<span class="fa fa-times-circle-o red"></span>', 'Refresh Restore Points Operation Failed');
        break;
      default:
        iconStyle = '<span/>';
    }
  } else if(_.indexOf(DEL_VAPP_OK_STATES, row.properties.state) != -1){
    switch (row.properties.operation) {
      case 'VAPP_RESTORE_POINT_DELETION_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-check-circle-o green"></span>', 'Delete All Restore Points Operation Succeeded');
        break;
      case 'REFRESH_VAPP_RESTORE_POINTS':
        iconStyle = createToolTip('<span class="fa fa-check-circle-o green"></span>', 'Refresh Restore Points Operation Succeeded');
        break;
      default:
        iconStyle = '<span/>';
    }
  }
  //TODO - More State Checks
  return iconStyle;
}

//vApps Modal specific
const VAPP_BUSY_STATES = ['INITIATED', 'VALIDATED', 'STARTED', 'TASK_IN_PROGRESS', 'VAPP_RESTORE','VAPP_POST_RESTORE','SCHEDULE_DELETE','SCHEDULE_UPDATE','VAPP_METADATA_REPLICATION_COMPLETE'];
const VAPP_WARNING_STATES = ['VAPP_RESTORE_PARTIAL_SUCCESS', 'VAPP_BACKUP_PARTIAL_SUCCESS'];
const VAPP_ERROR_STATES = ['VAPP_RESTORE_FAIL', 'VAPP_BACKUP_FAIL', 'JOB_FAILED'];
const VAPP_OK_STATES = ['TASK_COMPLETED','JOB_COMPLETED' ,'VAPP_BACKUP_SUCCESS' , 'VAPP_RESTORE_SUCCESS','CANCELLED'];
const VAPP_SUSPENDED_STATES = ['JOB_SUSPENDED'];

function arrowRenderToExpand(data, type, row, field){
  var subrowStyle = '<span></span>';
  if(row && row[field]) {
    subrowStyle = '<span class="details-control"></span>';
  }
  return subrowStyle;
}

function lastBackupRenderVapp(data, type, row){
  var returnString = ' - ';
  if(row && row.statistics && row.statistics.lastSuccessfulBackupTime) {
    returnString = row.statistics.lastSuccessfulBackupTime;
  }
  return returnString;
}

function ongoingRenderVapp(data, type, row){
  var iconStyle = "";
  if(!row || !row.properties || !row.properties.state || !row.properties.operation){
    return '';
  }

  if(_.indexOf(VAPP_BUSY_STATES, row.properties.state) != -1){
    switch (row.properties.operation) {
      case 'VAPP_ADHOC_BACKUP_WORKFLOW':
        iconStyle = createToolTip('<span class="spinner spinner-inline"></span>', 'Ongoing Backup');
        break;
      case 'VAPP_ADHOC_BACKUP':
        iconStyle = createToolTip('<span class="spinner spinner-inline"></span>', 'Ongoing Adhoc Backup');
        break;
      case 'VAPP_SCHEDULE_BACKUP':
        iconStyle = createToolTip('<span class="spinner spinner-inline"></span>', 'Ongoing Schedule Backup');
        break;
      case 'VAPP_RESTORE_WORKFLOW':
        iconStyle = createToolTip('<span class="spinner spinner-inline"></span>', 'Ongoing Restore');
        break;
      case 'VAPP_RESTORE_POINT_DELETION_WORKFLOW':
        iconStyle = createToolTip('<span class="spinner spinner-inline"></span>', 'Ongoing Delete All Restore Points');
        break;
      case 'REFRESH_VAPP_RESTORE_POINTS':
        iconStyle = createToolTip('<span class="spinner spinner-inline"></span>', 'Ongoing Refresh Restore Points');
        break;
      case 'CANCEL_VAPP_JOB':
        iconStyle = createToolTip('<span class="spinner spinner-inline"></span>', 'Ongoing Cancel Operation');
        break;
      case 'UPDATE_VAPP_BACKUP_RETENTION':
        iconStyle = createToolTip('<span class="spinner spinner-inline"></span>', 'Ongoing Expiry Date Change');
        break;
      case 'VAPP_ADHOC_REPLICATION_WORKFLOW':
        iconStyle = createToolTip('<span class="spinner spinner-inline"></span>', 'Ongoing Replication Operation');
        break;
      default:
        iconStyle = '<span/>';
    }
  }else if(_.indexOf(VAPP_WARNING_STATES, row.properties.state) != -1){
    switch (row.properties.operation) {
      case 'VAPP_ADHOC_BACKUP_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Backup Partially Successful');
        break;
      case 'VAPP_ADHOC_BACKUP':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Adhoc Backup Partially Successful');
        break;
      case 'VAPP_SCHEDULE_BACKUP':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Schedule Backup Partially Successful');
        break;
      case 'VAPP_RESTORE_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Restore Partially Successful');
        break;
      case 'VAPP_RESTORE_POINT_DELETION_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Delete All Restore Points is Partially Successful');
        break;
      case 'REFRESH_VAPP_RESTORE_POINTS':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Refresh Restore Points is Partially Successful');
        break;
      case 'CANCEL_VAPP_JOB':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Cancel Operation is Partially Successful');
        break;
      case 'UPDATE_VAPP_BACKUP_RETENTION':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Expiry Date Change is Partially Successful');
        break;
      case 'VAPP_ADHOC_REPLICATION_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Replication Operation is Partially Successful');
        break;
      default:
        iconStyle = '<span/>';
    }
  } else if(_.indexOf(VAPP_ERROR_STATES, row.properties.state) != -1){
    switch (row.properties.operation) {
      case 'VAPP_ADHOC_BACKUP_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-times-circle-o red"></span>', 'Backup Failed');
        break;
      case 'VAPP_ADHOC_BACKUP':
        iconStyle = createToolTip('<span class="fa fa-times-circle-o red"></span>', 'Adhoc Backup Failed');
        break;
      case 'VAPP_SCHEDULE_BACKUP':
        iconStyle = createToolTip('<span class="fa fa-times-circle-o red"></span>', 'Schedule Backup Failed');
        break;
      case 'VAPP_RESTORE_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-times-circle-o red"></span>', 'Restore Failed');
        break;
      case 'VAPP_RESTORE_POINT_DELETION_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-times-circle-o red"></span>', 'Delete All Restore Failed');
        break;
      case 'REFRESH_VAPP_RESTORE_POINTS':
        iconStyle = createToolTip('<span class="fa fa-times-circle-o red"></span>', 'Refresh Restore Points Failed');
        break;
      case 'CANCEL_VAPP_JOB':
        iconStyle = createToolTip('<span class="fa fa-times-circle-o red"></span>', 'Cancel Operation Failed');
        break;
      case 'UPDATE_VAPP_BACKUP_RETENTION':
        iconStyle = createToolTip('<span class="fa fa-times-circle-o red"></span>', 'Expiry Date Change Failed');
        break;
      case 'VAPP_ADHOC_REPLICATION_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-times-circle-o red"></span>', 'Replication Operation Failed');
        break;
      default:
        iconStyle = '<span/>';
    }
  } else if(_.indexOf(VAPP_OK_STATES, row.properties.state) != -1){
    switch (row.properties.operation) {
      case 'VAPP_ADHOC_BACKUP_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-check-circle-o green"></span>', 'Backup Succeeded');
        break;
      case 'VAPP_ADHOC_BACKUP':
        iconStyle = createToolTip('<span class="fa fa-check-circle-o green"></span>', 'Adhoc Backup Succeeded');
        break;
      case 'VAPP_SCHEDULE_BACKUP':
        iconStyle = createToolTip('<span class="fa fa-check-circle-o green"></span>', 'Schedule Backup Succeeded');
        break;
      case 'VAPP_RESTORE_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-check-circle-o green"></span>', 'Restore Succeeded');
        break;
      case 'VAPP_RESTORE_POINT_DELETION_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-check-circle-o green"></span>', 'Delete All Restore Succeeded');
        break;
      case 'REFRESH_VAPP_RESTORE_POINTS':
        iconStyle = createToolTip('<span class="fa fa-check-circle-o green"></span>', 'Refresh Restore Points Succeeded');
        break;
      case 'CANCEL_VAPP_JOB':
        iconStyle = createToolTip('<span class="fa fa-check-circle-o green"></span>', 'Cancel Operation Succeeded');
        break;
      case 'UPDATE_VAPP_BACKUP_RETENTION':
        iconStyle = createToolTip('<span class="fa fa-check-circle-o green"></span>', 'Expiry Date Change Succeeded');
        break;
      case 'VAPP_ADHOC_REPLICATION_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-check-circle-o green"></span>', 'Replication Operation Succeeded');
        break;
      default:
        iconStyle = '<span/>';
    }
  }else if(_.indexOf(VAPP_SUSPENDED_STATES, row.properties.state) != -1){
    switch (row.properties.operation) {
      case 'VAPP_ADHOC_BACKUP_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Backup Suspended');
        break;
      case 'VAPP_ADHOC_BACKUP':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Adhoc Backup Suspended');
        break;
      case 'VAPP_SCHEDULE_BACKUP':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Schedule Backup Suspended');
        break;
      case 'VAPP_RESTORE_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Restore Suspended');
        break;
      case 'VAPP_RESTORE_POINT_DELETION_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Delete All Restore Suspended');
        break;
      case 'REFRESH_VAPP_RESTORE_POINTS':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Refresh Restore Points Suspended');
        break;
      case 'CANCEL_VAPP_JOB':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Cancel Operation Suspended');
        break;
      case 'UPDATE_VAPP_BACKUP_RETENTION':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Expiry Date Change Suspended');
        break;
      case 'VAPP_ADHOC_REPLICATION_WORKFLOW':
        iconStyle = createToolTip('<span class="fa fa-exclamation-circle orange"></span>', 'Replication Operation Suspended');
        break;
      default:
        iconStyle = '<span/>';
    }
  }
  //TODO - More State Checks
  return iconStyle;
}

function activityLogRenderVapp(data, type, row){
  var iconStyle = createToolTip('<span class="fa fa-th-list handcursor"></span>', 'Activity Log');
  return iconStyle;
}

function constructInnerTableVapp(d, translate) { // `d` is the original data object for the row
  var innerTableRows = '';
  if(d.hasOwnProperty("vms") && d.vms.length > 0) {
    for(var x = 0; x < d.vms.length; x++) {
      innerTableRows += '<tr>'+
                          '<td>&nbsp;</td>'+
                          '<td>&nbsp;</td>'+
                          '<td>' + truncateString(d.vms[x].name) + '</td>'+
                          '<td>' + statusFormatter(d.vms[x].status, translate) + '</td>'+
                          '<td>&nbsp;</td>'+
                        '</tr>';
    }
    return '<div class="slider" width="100%">'+
        '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;" width="100%">'+
            '<thead width="100%">'+
              '<tr style="background-color:#FFF;">'+
                  '<th></th>'+
                  '<th></th>'+
                  '<th>VM</th>'+
                  '<th>Status</th>'+
                  '<th></th>'+
              '</tr>'+
          '</thead>'+
            innerTableRows+
        '</table>'+
    '</div>';
  }else{
      return '<div class="slider" width="100%">'+
      '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;" width="100%">'+
      '<tr>'+
      '<td style="text-align:center;">No Virtual Machines</div></td>'+
      '</tr>' +
      '</table>'+
    '</div>';
  }
}

function constructInnerTableRestorePoints(d, translate) { // `d` is the original data object for the row
  var innerTableRows = '';
  if(d.hasOwnProperty("children") && d.children.length > 0) {
    for(var x = 0; x < d.children.length; x++) {
      var vmSize,
          entityName,
          creationDate,
          expiryDate,
          storageConsumed,
          vmStatus;

      vmSize = (d.children[x] && d.children[x].size && d.children[x].size > 0) ? storageConverterRender(d.children[x].size, 'MB') : "0 MB";
      entityName = (d.children[x] && d.children[x].entityName) ? truncateString(d.children[x].entityName) : "-";
      creationDate = (d.children[x] && d.children[x].creationDate) ? genericDateFormatterWithToolTip(d.children[x].creationDate) : "-";
      expiryDate = (d.children[x] && d.children[x].expiryDate) ? genericDateFormatterWithToolTip(d.children[x].expiryDate) : "-";
      storageConsumed = (d.children[x] && d.children[x].storageConsumed) ? storageConverterRender(d.children[x].storageConsumed, 'MB') : "0 MB";


      if(d.children[x] && d.children[x].status) {
        vmStatus = statusFormatter(d.children[x].status, translate);
      }else{
        vmStatus = "-";
      }

      innerTableRows += '<tr>'+
                          '<td>&nbsp;</td>'+
                          '<td>&nbsp;</td>'+
                          '<td>'+entityName+'</td>'+
                          '<td>'+creationDate+'</td>'+
                          '<td>'+expiryDate+'</td>'+
                          '<td>'+vmStatus+'</td>'+
                          '<td>'+vmSize+'</td>'+
                          '<td>'+storageConsumed+'</td>'+
                          '<td>&nbsp;</td>'+
                        '</tr>';
    }
    return '<div class="slider" width="100%">'+
        '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;" width="100%">'+
            '<thead width="100%">'+
              '<tr style="background-color:#FFF;" >'+
                  '<th></th>'+
                  '<th></th>'+
                  '<th>VM</th>'+
                  '<th>Creation Date</th>'+
                  '<th>Expiry Date</th>'+
                  '<th>Status</th>'+
                  '<th>Size</th>'+
                  '<th>Storage Consumed</th>'+
                  '<th></th>'+
              '</tr>'+
          '</thead>'+
            innerTableRows+
        '</table>'+
    '</div>';
  }else{
    return '<div class="slider" width="100%">'+
      '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;" width="100%">'+
      '<tr>'+
      '<td style="text-align:center;">No Virtual Machines</div></td>'+
      '</tr>' +
      '</table>'+
    '</div>';
  }
}

//Restore Points specific
function dateRenderForSort(data, type, row, dateField){
  var returnString = ' - ';
  if(row && row.statistics && row.statistics.lastSuccessfulBackupTime) {
    returnString = row.statistics.lastSuccessfulBackupTime;
  }
  return returnString;
}

function changeExpiryRender(data, type, row){
  var subrowStyle = '';
  if(row && row.children) {
    subrowStyle = createToolTip('<clr-icon shape="calendar" class="expiry-action"></clr-icon>', 'Change Expiry Date');
  }
  return subrowStyle;
}



/* Export section */
export { handleEmptyValues as handleEmptyValues, truncateString as truncateString };
export { genericStringFormatter as genericStringFormatter, genericDateFormatter as genericDateFormatter, genericDateFormatterWithToolTip as genericDateFormatterWithToolTip };
export { restorePointRender as restorePointRender, statusRender as statusRender };
export { storageRender as storageRender };
export { policyRender as policyRender, policyFormatter as policyFormatter, tooltipFormatter as tooltipFormatter, replicationTooltipFormatter as replicationTooltipFormatter };
export { statusRenderActivityLog as statusRenderActivityLog };
export { ongoingRenderDeletedVapps as ongoingRenderDeletedVapps };
export { arrowRenderToExpand as arrowRenderToExpand, lastBackupRenderVapp as lastBackupRenderVapp, ongoingRenderVapp as ongoingRenderVapp, activityLogRenderVapp as activityLogRenderVapp, constructInnerTableVapp as constructInnerTableVapp };
export { timezones as timezones };
export { changeExpiryRender as changeExpiryRender, dateRenderForSort as dateRenderForSort, storageConverterRender as storageConverterRender, constructInnerTableRestorePoints as constructInnerTableRestorePoints };
export { findTZLabel as findTimezoneKeyFromValue, retentionFormatter as retentionFormatter };


// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-common/common-renderers.ts